import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=61f0e4ba&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=61f0e4ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f0e4ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61f0e4ba')) {
      api.createRecord('61f0e4ba', component.options)
    } else {
      api.reload('61f0e4ba', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=61f0e4ba&scoped=true&", function () {
      api.rerender('61f0e4ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2M9bl5iNKbb38/JS/comp/DocBox.vue"
export default component.exports